import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=cb9b3a16&"
import script from "./Assign.vue?vue&type=script&lang=ts&"
export * from "./Assign.vue?vue&type=script&lang=ts&"
import style0 from "./Assign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports